import { FACE_KEYS } from '@repo/api-contracts';
import type { EditAreaDraftState } from './edit-area-draft-types';

/** 서버 표시 URL·선택·순서만 바뀐 색상 조회는 저장 값의 변경이 아니다. */
export const editAreaDraftSnapshot = (
  state: Pick<EditAreaDraftState, 'components' | 'faces' | 'draft'>,
): string =>
  JSON.stringify({
    components: state.components,
    faces: FACE_KEYS.flatMap((face) => (state.faces[face] ? [[face, state.faces[face]]] : [])),
    colors: [...state.draft.colors]
      .sort((a, b) => a.colorOptionId.localeCompare(b.colorOptionId))
      .map((color) => ({
        colorOptionId: color.colorOptionId,
        faces: FACE_KEYS.flatMap((face) => {
          const photo = color.faces[face];
          return photo ? [[face, { photoKey: photo.photoKey, photoSize: photo.photoSize }]] : [];
        }),
      })),
  });
